import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dashboard-grid" }
const _hoisted_2 = {
  ref: "grid",
  class: "grid-stack"
}
const _hoisted_3 = { class: "center w-100 loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widgets, (widget) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(widget.type), {
          key: widget.id,
          widget: widget,
          widgetMode: _ctx.mode
        }, null, 8 /* PROPS */, ["widget", "widgetMode"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.ready]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_n_spin)
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.ready]
    ])
  ]))
}